export default __webpack_public_path__ + "static/media/listview_active.8c62eb09.svg";